import {reactive} from 'vue';
import _ from "lodash";
import {IndustryData, StateData, ModalData} from "@/data";

function createUUID() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";
    return s.join("");
}

function makeNewLocation() {
    let id = createUUID();
    return {
        id: id,
        state: "NA",
        employees: null,
        employeeErrors: false,
        stateErrors: false,
        calculations: {
            NumEmployeesWithDistress: -1,
            NumDependentsWithDistress: -1,
            HealthcareCost: -1,
            AbsenteeismCost: -1,
            TurnoverCost: -1,
            OverallCosts: -1,
        },
    };
}

function disableScroll() {
    console.log("disable");
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    window.onscroll = function() {
        window.scrollTo(scrollLeft, scrollTop);
    };
}
function enableScroll() {
    console.log("enable");
    window.onscroll = function() {};
}

const store = {
    debug: false,
    
    state: reactive({
        email: "",
        emailError: false,
        locations: {},
        industry: null,
        industryError: false,
        showModal: false,
        selectedModal: null
    }),
    addLocation() {
        let newLocation = makeNewLocation();
        this.state.locations[newLocation.id] = newLocation;
    },
    clearLocations() {
        this.state.industry = null;
        this.state.locations = {};  
    },
    updateLocationState(id, newState) {
        this.state.locations[id].state = newState;
    },
    updateLocationEmployeeCount(id, newCount) {
        this.state.locations[id].employees = newCount;
    },
    updateSelectedIndustry(newIndustry) {
        this.state.industry = newIndustry;
    },
    updateLocationCalculations(locationID, calculations) {
        this.state.locations[locationID].calculations = calculations;
    },
    showModal(modal){
        this.state.showModal = true;
        this.state.selectedModal = ModalData[modal];
        disableScroll();
    },
    hideModal(){
        this.state.showModal = false;
        enableScroll();
    },
    getURIInfo() {
        return {
            industry: this.state.industry.ID,
            locations: (btoa(JSON.stringify(_.map(this.state.locations, item => {
                return { employees: item.employees, state: item.state.ID }    
            }))))
        }
    },
    loadFromURI(industry, locations){
        this.state.industry = IndustryData.find(x => x.ID == industry);
        locations.forEach((item) => {
            let newLocation = makeNewLocation();
            newLocation.state = StateData[item.state];
            newLocation.employees = item.employees;
            this.state.locations[newLocation.id] = newLocation; 
        });
    },
    validate() {
        let allowSubmit = true;
        let toValidate = _.map(this.state.locations, location => {
            let temploc = location;
            if (location.employees === null || location.employees < 1) {
                temploc.employeeErrors = true;
            } else {
                temploc.employeeErrors = false;
            }
            if (location.state === "NA") {
                temploc.stateErrors = true;
            } else {
                temploc.stateErrors = false;
            }
            return temploc;
        });

        _.forEach(toValidate, location => {
            if (location.employeeErrors === true || location.stateErrors === true) {
                allowSubmit = false;
            }
        })

        if (this.state.industry === null) {
            this.state.industryError = true;
            allowSubmit = false;
        } else {
            this.state.industryError = false;
        }
        
        if(this.state.email == null || this.state.email === ""){
            this.state.emailError = true;
            allowSubmit = false;
        } else {
            this.state.emailError = false;
        }
        
        return allowSubmit;
    },
    computeResults() {
        Object.entries(this.state.locations).forEach(key => {key[1].calculations = this.calculate(key[1])});
    },
    calculate(location) {
        //let ratioEmployeed = StateData.find(x=>x.ID == location.state.ID ).RatioToNationalEmployed;
        //let ratioGeneral = StateData.find(x=>x.ID == location.state.ID).RatioToNationalGeneral;
        let state = location.state;
        let industry = this.state.industry;
        let DependentsAdjuster = 1.18;
        let EmployerPremiumIndividual = 2812;
        let EmployerPremiumFamily = 1924;
        let nationalPercent = 0.109;
        let turnoverModifer = 0.352;
        let daysOfWorkMissedIllnessModifier = 9.31;
        let daysOfWorkSkippedModifier = 6.72; 
        let hospitalDaysModifier = 0.2422;
        let erVisitModifier = 0.335;
        let primaryCareVisitModifier = 3.1144;
        let safetyRiskModifier = 12*0.017;

        let employeesWithDistress = Math.round(industry.DistressFactor * location.employees * state.RatioToNationalEmployed);
        
        let estimatedDependents = Math.round(location.employees * DependentsAdjuster);
        let dependentsWithDistress = Math.round(estimatedDependents * state.RatioToNationalGeneral * nationalPercent);

        //let comorbidSudEmployedModifier = 0.334
        let comorbidSudGeneralModifier = 0.333 
        //let suicidalIdeationEmployedModifier = 0.063
        let suicidalIdeationGeneralModifier = 0.059 
        //let depressionEmployedModifier = 0.075 
        let depressionGeneralModifier = 0.075 
        let anxietyEmployedModifier = 0.044
        let anxietyGeneralModifier = 0.059 

        
        
        let healthcarecost = Math.round(employeesWithDistress * EmployerPremiumIndividual + dependentsWithDistress * EmployerPremiumFamily);
        let absenteeismcost = Math.round(employeesWithDistress * industry.AbsenteeismCost);
        let turnovercost = Math.round(employeesWithDistress * industry.TurnoverCost);
        console.log()
        return {
            NumEmployeesWithDistress: employeesWithDistress,
            NumDependentsWithDistress: dependentsWithDistress,
            HealthcareCost: healthcarecost,
            AbsenteeismCost: absenteeismcost,
            TurnoverCost: turnovercost,
            OverallCosts: Math.round(healthcarecost + absenteeismcost + turnovercost),
            Turnover: Math.round(turnoverModifer * employeesWithDistress), 
            DaysSick: Math.round(daysOfWorkMissedIllnessModifier * employeesWithDistress),
            DaysSkipped: Math.round(daysOfWorkSkippedModifier * employeesWithDistress),
            HospitalDays: Math.round(hospitalDaysModifier * employeesWithDistress),
            ERVisits: Math.round(erVisitModifier * employeesWithDistress),
            PrimaryCareVisits: Math.round(primaryCareVisitModifier * employeesWithDistress),
            EmployeesWhoCauseSafetyIncident: Math.round(safetyRiskModifier * employeesWithDistress),
            EmployeesWithComorbidSUD: Math.round(location.employees* state.ComorbidSUDFactor * industry.RatioToAverage),
            GeneralWithComorbidSUD: Math.round(dependentsWithDistress* comorbidSudGeneralModifier * industry.RatioToAverage),
            EmployedSuicidalIdeation: Math.round(location.employees* state.SuicidalFactor* industry.RatioToAverage),
            GeneralWithSuicidalIdeation: Math.round(estimatedDependents * suicidalIdeationGeneralModifier),
            EmployedWithDepression: Math.round(location.employees* state.DepressionFactor*industry.RatioToAverage),
            GeneralWithDepression: Math.round(estimatedDependents * depressionGeneralModifier),
            EmployedWithAnxiety: Math.round(location.employees* anxietyEmployedModifier * industry.RatioToAverage),
            GeneralWithAnxiety: Math.round(estimatedDependents * anxietyGeneralModifier * industry.RatioToAverage)
        };
    }
}

export default store;